import { cn } from "~/lib/utils";
import { getCatalogIconStyles } from "../../lib/getCatalogIconStyles";

// // // //

export type CatalogIconSize = "sm" | "md" | "lg";

// Badge + icon sizing per size. `sm` suits dense lists and sidebars, `md` is
// the card default, `lg` is for page headers.
const SIZE_CLASS_NAMES: Record<
    CatalogIconSize,
    { badge: string; icon: string }
> = {
    sm: { badge: "size-5 rounded-md", icon: "size-3" },
    md: { badge: "size-9 rounded-lg", icon: "size-4" },
    lg: { badge: "size-10 rounded-md", icon: "size-5" },
};

/**
 * CatalogIcon
 * A catalog item's icon in a square badge tinted with its color. Accepts the
 * raw `icon` + `color` values as stored on Measure and ReferenceData.
 */
export function CatalogIcon(props: {
    icon?: string | null;
    color?: string | null;
    size?: CatalogIconSize;
    className?: string;
}) {
    const { icon, color, size = "md", className } = props;

    const { Icon, iconClassName, bgClassName } = getCatalogIconStyles({
        icon,
        color,
    });
    const sizeClassNames = SIZE_CLASS_NAMES[size];

    return (
        <span
            className={cn(
                "flex shrink-0 items-center justify-center",
                sizeClassNames.badge,
                bgClassName,
                className,
            )}
        >
            <Icon
                className={cn("shrink-0", sizeClassNames.icon, iconClassName)}
            />
        </span>
    );
}
